import React from 'react';
import { useTranslation } from '../i18n';
import { parseHotelData, parseStructuredMessage, linkifyText } from '../utils/helpers';
import HotelCard from './HotelCard';
import StructuredMessageRenderer from './StructuredMessageRenderer';

export default function ChatMessage({ msg, index, onHotelSelect, onImageClick, onExportPdf, onShareItinerary, onReportBug, copiedToClipboard, setCopiedToClipboard }) {
  const { t } = useTranslation();
  const isUser = msg.role === 'user';
  const hotelData = !isUser ? parseHotelData(msg.content) : null;
  const hasHotelData = hotelData && Array.isArray(hotelData) && hotelData.length > 0;
  const structuredMessage = !isUser ? parseStructuredMessage(msg.fullResponse) : null;
  const hasStructuredMessage = Boolean(structuredMessage);
  const hasShareBtn = !isUser && structuredMessage?.messageType === 'itinerary';

  return (
    <div id={`chat-message-${index}`} className={`message-wrapper ${isUser ? 'user-message' : ''}`}>
      <div
        id={!isUser ? `agent-message-${index}` : undefined}
        className={`message-content ${isUser ? 'user-message' : ''} ${hasHotelData ? 'hotel-data premium-glow' : 'premium-glow'}`}
      >
        {hasHotelData ? (
          <>
            <div className="hotel-intro">
              {t('hotel.intro')}
            </div>
            <div className="hotel-grid">
              {hotelData.map((hotel, hotelIndex) => {
                const hotelImageUrls = hotelData.map(hotelItem => hotelItem.image || hotelItem.imageUrl || hotelItem.photo || 'https://images.unsplash.com/photo-1566073771259-6a8506099945?w=400&h=300&fit=crop');
                return (
                  <HotelCard
                    key={hotelIndex}
                    hotel={hotel}
                    onSelect={onHotelSelect}
                    onImageClick={onImageClick}
                    imageUrls={hotelImageUrls}
                    imageIndex={hotelIndex}
                  />
                )
              })}
            </div>
          </>
        ) : hasStructuredMessage ? (
          <StructuredMessageRenderer
            structuredMessage={structuredMessage}
          />
        ) : (
          <div className="message-text">
            {linkifyText(msg.content || msg.message || JSON.stringify(msg))}
          </div>
        )}
      </div>
      {hasShareBtn && (
        <div className="share-buttons">
          <button
            type="button"
            className="share-pdf-btn"
            onClick={() => onExportPdf(index)}
            title={t('share.exportPdf')}
          >
            <span className="material-symbols-outlined">download</span>
          </button>
          <button
            type="button"
            className="share-pdf-btn"
            onClick={() => onReportBug()}
            title={t('bug.reportBug')}
          >
            <span className="material-symbols-outlined">bug_report</span>
          </button>
          <div style={{ position: 'relative' }}>
            <button
              type="button"
              className="share-pdf-btn"
              onClick={() => onShareItinerary(msg.fullResponse)}
            >
              <span className="material-symbols-outlined">share</span>
            </button>
            {copiedToClipboard && (
              <div className="share-tooltip show">
                {t('share.linkCopied')}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
}
